import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "512",
  height: "512",
  viewBox: "0 0 135.467 135.467"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M98.257 77.972c-3.305.642-6.58.868-9.79 2.116-8.295 3.226-15.506 9.318-19.534 17.375-12.904 25.807 10.067 56.786 38.585 51.24 16.893-3.284 30.824-19.522 29.104-37.218-1.58-16.258-12.637-29.52-28.84-32.896-2.913-.607-6.544-1.197-9.525-.617m-8.466 79.375c-5.032.978-9.918 1.27-14.817 3.175-14.06 5.467-24.606 16.432-30.207 30.338-1.962 4.873-2.398 9.735-3.175 14.817-.337 2.21-.756 5.376 1.367 6.88 2.15 1.52 5.958.793 8.467.793h97.102c2.72 0 6.086.536 8.731-.088 4.337-1.024 3.366-6.984 2.734-10.23-1.803-9.274-4.305-17.782-10.23-25.4-7.848-10.09-18.867-17.055-31.397-19.492-5.311-1.032-10.719-.882-16.14-.882-3.946 0-8.567-.664-12.435.089",
      style: {"fill":"#e3d395","stroke":"none"},
      transform: "translate(-33.17 -77.883)"
    }, null, -1)
  ]))]))
}
export default { render: render }